export var AgeRangeOption = /*#__PURE__*/function (AgeRangeOption) {
  AgeRangeOption[AgeRangeOption["underEighteen"] = 1] = "underEighteen";
  AgeRangeOption[AgeRangeOption["eighteenToNineteen"] = 2] = "eighteenToNineteen";
  AgeRangeOption[AgeRangeOption["twenties"] = 3] = "twenties";
  AgeRangeOption[AgeRangeOption["thirties"] = 4] = "thirties";
  AgeRangeOption[AgeRangeOption["forties"] = 5] = "forties";
  AgeRangeOption[AgeRangeOption["fiftyPlus"] = 6] = "fiftyPlus";
  return AgeRangeOption;
}(AgeRangeOption || {});
export var AvgCycleLengthOption = /*#__PURE__*/function (AvgCycleLengthOption) {
  AvgCycleLengthOption[AvgCycleLengthOption["lessThanTwentyOne"] = 1] = "lessThanTwentyOne";
  AvgCycleLengthOption[AvgCycleLengthOption["twentyOneToTwentyEight"] = 2] = "twentyOneToTwentyEight";
  AvgCycleLengthOption[AvgCycleLengthOption["twentyEightToThirtyFive"] = 3] = "twentyEightToThirtyFive";
  AvgCycleLengthOption[AvgCycleLengthOption["moreThanThirtyFive"] = 4] = "moreThanThirtyFive";
  AvgCycleLengthOption[AvgCycleLengthOption["notSure"] = 5] = "notSure";
  return AvgCycleLengthOption;
}(AvgCycleLengthOption || {});
export var PeriodRegularityOption = /*#__PURE__*/function (PeriodRegularityOption) {
  PeriodRegularityOption[PeriodRegularityOption["canUsuallyPredict"] = 1] = "canUsuallyPredict";
  PeriodRegularityOption[PeriodRegularityOption["canSometimesPredict"] = 2] = "canSometimesPredict";
  PeriodRegularityOption[PeriodRegularityOption["hardToPredict"] = 3] = "hardToPredict";
  return PeriodRegularityOption;
}(PeriodRegularityOption || {});
export var DiscussedFertilityOption = /*#__PURE__*/function (DiscussedFertilityOption) {
  DiscussedFertilityOption[DiscussedFertilityOption["yesIHave"] = 1] = "yesIHave";
  DiscussedFertilityOption[DiscussedFertilityOption["noButGoingTo"] = 2] = "noButGoingTo";
  DiscussedFertilityOption[DiscussedFertilityOption["noDontPlanTo"] = 3] = "noDontPlanTo";
  return DiscussedFertilityOption;
}(DiscussedFertilityOption || {});
export var PartnerInvolvementOption = /*#__PURE__*/function (PartnerInvolvementOption) {
  PartnerInvolvementOption[PartnerInvolvementOption["veryInvolved"] = 1] = "veryInvolved";
  PartnerInvolvementOption[PartnerInvolvementOption["someWhatInvolved"] = 2] = "someWhatInvolved";
  PartnerInvolvementOption[PartnerInvolvementOption["notInvolved"] = 3] = "notInvolved";
  PartnerInvolvementOption[PartnerInvolvementOption["noPartner"] = 4] = "noPartner";
  return PartnerInvolvementOption;
}(PartnerInvolvementOption || {});
export var EmotionsOption = /*#__PURE__*/function (EmotionsOption) {
  EmotionsOption[EmotionsOption["happiness"] = 1] = "happiness";
  EmotionsOption[EmotionsOption["confidence"] = 2] = "confidence";
  EmotionsOption[EmotionsOption["calmness"] = 3] = "calmness";
  EmotionsOption[EmotionsOption["energyLevels"] = 4] = "energyLevels";
  EmotionsOption[EmotionsOption["stress"] = 5] = "stress";
  EmotionsOption[EmotionsOption["PMS"] = 6] = "PMS";
  EmotionsOption[EmotionsOption["anger"] = 7] = "anger";
  EmotionsOption[EmotionsOption["moodSwings"] = 8] = "moodSwings";
  EmotionsOption[EmotionsOption["numbness"] = 9] = "numbness";
  EmotionsOption[EmotionsOption["anxiety"] = 10] = "anxiety";
  EmotionsOption[EmotionsOption["irritability"] = 11] = "irritability";
  EmotionsOption[EmotionsOption["tiredness"] = 12] = "tiredness";
  EmotionsOption[EmotionsOption["sensitivity"] = 13] = "sensitivity";
  return EmotionsOption;
}(EmotionsOption || {});
export var EmotionalRangeOption = /*#__PURE__*/function (EmotionalRangeOption) {
  EmotionalRangeOption[EmotionalRangeOption["moodSwingsFrequent"] = 1] = "moodSwingsFrequent";
  EmotionalRangeOption[EmotionalRangeOption["moodSwingsSomewhatFrequent"] = 2] = "moodSwingsSomewhatFrequent";
  EmotionalRangeOption[EmotionalRangeOption["moodSwingsRare"] = 3] = "moodSwingsRare";
  return EmotionalRangeOption;
}(EmotionalRangeOption || {});
export var TypeOfPainOption = /*#__PURE__*/function (TypeOfPainOption) {
  TypeOfPainOption[TypeOfPainOption["cramps"] = 1] = "cramps";
  TypeOfPainOption[TypeOfPainOption["backache"] = 2] = "backache";
  TypeOfPainOption[TypeOfPainOption["soreBreasts"] = 3] = "soreBreasts";
  TypeOfPainOption[TypeOfPainOption["ovulationPain"] = 4] = "ovulationPain";
  TypeOfPainOption[TypeOfPainOption["headache"] = 5] = "headache";
  return TypeOfPainOption;
}(TypeOfPainOption || {});
export var SkinChangesOption = /*#__PURE__*/function (SkinChangesOption) {
  SkinChangesOption[SkinChangesOption["dryness"] = 1] = "dryness";
  SkinChangesOption[SkinChangesOption["glowy"] = 2] = "glowy";
  SkinChangesOption[SkinChangesOption["acne"] = 3] = "acne";
  SkinChangesOption[SkinChangesOption["puffiness"] = 4] = "puffiness";
  SkinChangesOption[SkinChangesOption["oiliness"] = 5] = "oiliness";
  return SkinChangesOption;
}(SkinChangesOption || {});
export var LibidoChangesOption = /*#__PURE__*/function (LibidoChangesOption) {
  LibidoChangesOption[LibidoChangesOption["lowSexDrive"] = 1] = "lowSexDrive";
  LibidoChangesOption[LibidoChangesOption["highSexDrive"] = 2] = "highSexDrive";
  LibidoChangesOption[LibidoChangesOption["other"] = 3] = "other";
  return LibidoChangesOption;
}(LibidoChangesOption || {});
export var SexDriveChangesOption = /*#__PURE__*/function (SexDriveChangesOption) {
  SexDriveChangesOption[SexDriveChangesOption["variesALot"] = 1] = "variesALot";
  SexDriveChangesOption[SexDriveChangesOption["variesALittle"] = 2] = "variesALittle";
  SexDriveChangesOption[SexDriveChangesOption["doesNotVary"] = 3] = "doesNotVary";
  SexDriveChangesOption[SexDriveChangesOption["haveNotNoticed"] = 4] = "haveNotNoticed";
  return SexDriveChangesOption;
}(SexDriveChangesOption || {});
export var BleedingChangesOption = /*#__PURE__*/function (BleedingChangesOption) {
  BleedingChangesOption[BleedingChangesOption["spotting"] = 1] = "spotting";
  BleedingChangesOption[BleedingChangesOption["lightPeriod"] = 2] = "lightPeriod";
  BleedingChangesOption[BleedingChangesOption["mediumPeriod"] = 3] = "mediumPeriod";
  BleedingChangesOption[BleedingChangesOption["heavyPeriod"] = 4] = "heavyPeriod";
  return BleedingChangesOption;
}(BleedingChangesOption || {});
export var CervicalMucusChangesOption = /*#__PURE__*/function (CervicalMucusChangesOption) {
  CervicalMucusChangesOption[CervicalMucusChangesOption["sticky"] = 1] = "sticky";
  CervicalMucusChangesOption[CervicalMucusChangesOption["creamy"] = 2] = "creamy";
  CervicalMucusChangesOption[CervicalMucusChangesOption["light"] = 3] = "light";
  CervicalMucusChangesOption[CervicalMucusChangesOption["medium"] = 4] = "medium";
  CervicalMucusChangesOption[CervicalMucusChangesOption["heavy"] = 5] = "heavy";
  CervicalMucusChangesOption[CervicalMucusChangesOption["none"] = 6] = "none";
  CervicalMucusChangesOption[CervicalMucusChangesOption["eggWhite"] = 7] = "eggWhite";
  CervicalMucusChangesOption[CervicalMucusChangesOption["watery"] = 8] = "watery";
  return CervicalMucusChangesOption;
}(CervicalMucusChangesOption || {});
export var StatementDescriptionOption = /*#__PURE__*/function (StatementDescriptionOption) {
  StatementDescriptionOption[StatementDescriptionOption["routinesAreImportant"] = 1] = "routinesAreImportant";
  StatementDescriptionOption[StatementDescriptionOption["sometimesIHaveRoutines"] = 2] = "sometimesIHaveRoutines";
  StatementDescriptionOption[StatementDescriptionOption["notARoutinePerson"] = 3] = "notARoutinePerson";
  return StatementDescriptionOption;
}(StatementDescriptionOption || {});
export var SleepOption = /*#__PURE__*/function (SleepOption) {
  SleepOption[SleepOption["wakeUpOften"] = 1] = "wakeUpOften";
  SleepOption[SleepOption["sleepThroughTheNight"] = 2] = "sleepThroughTheNight";
  SleepOption[SleepOption["sleepVaries"] = 3] = "sleepVaries";
  return SleepOption;
}(SleepOption || {});
export var SleepWithTrackerOption = /*#__PURE__*/function (SleepWithTrackerOption) {
  SleepWithTrackerOption[SleepWithTrackerOption["yesWithRing"] = 1] = "yesWithRing";
  SleepWithTrackerOption[SleepWithTrackerOption["yesWithWatch"] = 2] = "yesWithWatch";
  SleepWithTrackerOption[SleepWithTrackerOption["yesWithBoth"] = 3] = "yesWithBoth";
  SleepWithTrackerOption[SleepWithTrackerOption["neither"] = 4] = "neither";
  return SleepWithTrackerOption;
}(SleepWithTrackerOption || {});
export var ConsideringPurchaseOption = /*#__PURE__*/function (ConsideringPurchaseOption) {
  ConsideringPurchaseOption[ConsideringPurchaseOption["yesAppleWatch"] = 1] = "yesAppleWatch";
  ConsideringPurchaseOption[ConsideringPurchaseOption["yesOuraRing"] = 2] = "yesOuraRing";
  ConsideringPurchaseOption[ConsideringPurchaseOption["no"] = 3] = "no";
  return ConsideringPurchaseOption;
}(ConsideringPurchaseOption || {});
export var PurchaseNewWatchOption = /*#__PURE__*/function (PurchaseNewWatchOption) {
  PurchaseNewWatchOption[PurchaseNewWatchOption["yes"] = 1] = "yes";
  PurchaseNewWatchOption[PurchaseNewWatchOption["no"] = 2] = "no";
  return PurchaseNewWatchOption;
}(PurchaseNewWatchOption || {});
export var WearWatchToBedOption = /*#__PURE__*/function (WearWatchToBedOption) {
  WearWatchToBedOption[WearWatchToBedOption["yes"] = 1] = "yes";
  WearWatchToBedOption[WearWatchToBedOption["no"] = 2] = "no";
  WearWatchToBedOption[WearWatchToBedOption["dontKnow"] = 3] = "dontKnow";
  // options for the B1 in signup flow
  WearWatchToBedOption[WearWatchToBedOption["noButOpenToIt"] = 4] = "noButOpenToIt";
  return WearWatchToBedOption;
}(WearWatchToBedOption || {});
export var TrueOrFalseOption = /*#__PURE__*/function (TrueOrFalseOption) {
  TrueOrFalseOption[TrueOrFalseOption["true"] = 1] = "true";
  TrueOrFalseOption[TrueOrFalseOption["false"] = 2] = "false";
  return TrueOrFalseOption;
}(TrueOrFalseOption || {});
export var BestTimeInCycleOption = /*#__PURE__*/function (BestTimeInCycleOption) {
  BestTimeInCycleOption[BestTimeInCycleOption["beforePeriod"] = 1] = "beforePeriod";
  BestTimeInCycleOption[BestTimeInCycleOption["duringPeriod"] = 2] = "duringPeriod";
  BestTimeInCycleOption[BestTimeInCycleOption["afterPeriod"] = 3] = "afterPeriod";
  BestTimeInCycleOption[BestTimeInCycleOption["dontKnow"] = 4] = "dontKnow";
  BestTimeInCycleOption[BestTimeInCycleOption["ratherNotSay"] = 5] = "ratherNotSay";
  return BestTimeInCycleOption;
}(BestTimeInCycleOption || {});
export var KnowingYourSexDriveOption = /*#__PURE__*/function (KnowingYourSexDriveOption) {
  KnowingYourSexDriveOption[KnowingYourSexDriveOption["veryWell"] = 1] = "veryWell";
  KnowingYourSexDriveOption[KnowingYourSexDriveOption["notVeryWell"] = 2] = "notVeryWell";
  KnowingYourSexDriveOption[KnowingYourSexDriveOption["notSure"] = 3] = "notSure";
  return KnowingYourSexDriveOption;
}(KnowingYourSexDriveOption || {});
export var SexFrequencyOption = /*#__PURE__*/function (SexFrequencyOption) {
  SexFrequencyOption[SexFrequencyOption["everyday"] = 1] = "everyday";
  SexFrequencyOption[SexFrequencyOption["fewTimesWeek"] = 2] = "fewTimesWeek";
  SexFrequencyOption[SexFrequencyOption["coupleTimesMonth"] = 3] = "coupleTimesMonth";
  SexFrequencyOption[SexFrequencyOption["lessThanOnceMonth"] = 4] = "lessThanOnceMonth";
  SexFrequencyOption[SexFrequencyOption["ratherNotSay"] = 5] = "ratherNotSay";
  return SexFrequencyOption;
}(SexFrequencyOption || {});
export var KnowPregnantDaysOption = /*#__PURE__*/function (KnowPregnantDaysOption) {
  KnowPregnantDaysOption[KnowPregnantDaysOption["yes"] = 1] = "yes";
  KnowPregnantDaysOption[KnowPregnantDaysOption["no"] = 2] = "no";
  KnowPregnantDaysOption[KnowPregnantDaysOption["notSure"] = 3] = "notSure";
  return KnowPregnantDaysOption;
}(KnowPregnantDaysOption || {});
export var TroubleGettingBackToSleepOption = /*#__PURE__*/function (TroubleGettingBackToSleepOption) {
  TroubleGettingBackToSleepOption[TroubleGettingBackToSleepOption["noTrouble"] = 1] = "noTrouble";
  TroubleGettingBackToSleepOption[TroubleGettingBackToSleepOption["someStruggle"] = 2] = "someStruggle";
  TroubleGettingBackToSleepOption[TroubleGettingBackToSleepOption["oftenAwakeAWhile"] = 3] = "oftenAwakeAWhile";
  return TroubleGettingBackToSleepOption;
}(TroubleGettingBackToSleepOption || {});
export var SleepConsistencyOption = /*#__PURE__*/function (SleepConsistencyOption) {
  SleepConsistencyOption[SleepConsistencyOption["regularHours"] = 1] = "regularHours";
  SleepConsistencyOption[SleepConsistencyOption["patternsFluctuate"] = 2] = "patternsFluctuate";
  SleepConsistencyOption[SleepConsistencyOption["irregularSleep"] = 3] = "irregularSleep";
  return SleepConsistencyOption;
}(SleepConsistencyOption || {});
export var HealthGoalsOption = /*#__PURE__*/function (HealthGoalsOption) {
  HealthGoalsOption[HealthGoalsOption["mentalHealth"] = 1] = "mentalHealth";
  HealthGoalsOption[HealthGoalsOption["sleepQuality"] = 2] = "sleepQuality";
  HealthGoalsOption[HealthGoalsOption["stress"] = 3] = "stress";
  HealthGoalsOption[HealthGoalsOption["physicalActivity"] = 4] = "physicalActivity";
  HealthGoalsOption[HealthGoalsOption["diet"] = 5] = "diet";
  HealthGoalsOption[HealthGoalsOption["screenTime"] = 6] = "screenTime";
  return HealthGoalsOption;
}(HealthGoalsOption || {});
export var BiggestStressorOption = /*#__PURE__*/function (BiggestStressorOption) {
  BiggestStressorOption[BiggestStressorOption["work"] = 1] = "work";
  BiggestStressorOption[BiggestStressorOption["health"] = 2] = "health";
  BiggestStressorOption[BiggestStressorOption["family"] = 3] = "family";
  BiggestStressorOption[BiggestStressorOption["finances"] = 4] = "finances";
  BiggestStressorOption[BiggestStressorOption["future"] = 5] = "future";
  BiggestStressorOption[BiggestStressorOption["other"] = 6] = "other";
  return BiggestStressorOption;
}(BiggestStressorOption || {});
export var FavoriteWayToUnwindOption = /*#__PURE__*/function (FavoriteWayToUnwindOption) {
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["meditating"] = 1] = "meditating";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["reading"] = 2] = "reading";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["timeWithFriends"] = 3] = "timeWithFriends";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["music"] = 4] = "music";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["exercising"] = 5] = "exercising";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["hobbies"] = 6] = "hobbies";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["selfCare"] = 7] = "selfCare";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["havingABath"] = 8] = "havingABath";
  FavoriteWayToUnwindOption[FavoriteWayToUnwindOption["other"] = 9] = "other";
  return FavoriteWayToUnwindOption;
}(FavoriteWayToUnwindOption || {});
export var DeviceTraitOption = /*#__PURE__*/function (DeviceTraitOption) {
  DeviceTraitOption[DeviceTraitOption["costConscious"] = 1] = "costConscious";
  DeviceTraitOption[DeviceTraitOption["premium"] = 2] = "premium";
  DeviceTraitOption[DeviceTraitOption["notSure"] = 3] = "notSure";
  return DeviceTraitOption;
}(DeviceTraitOption || {});
export var WhatToTrackWithDeviceOption = /*#__PURE__*/function (WhatToTrackWithDeviceOption) {
  WhatToTrackWithDeviceOption[WhatToTrackWithDeviceOption["cycle"] = 1] = "cycle";
  WhatToTrackWithDeviceOption[WhatToTrackWithDeviceOption["cycleAndMetrics"] = 2] = "cycleAndMetrics";
  WhatToTrackWithDeviceOption[WhatToTrackWithDeviceOption["notSure"] = 3] = "notSure";
  return WhatToTrackWithDeviceOption;
}(WhatToTrackWithDeviceOption || {});
export var WakeUpTimeConsistencyOption = /*#__PURE__*/function (WakeUpTimeConsistencyOption) {
  WakeUpTimeConsistencyOption[WakeUpTimeConsistencyOption["sameTime"] = 1] = "sameTime";
  WakeUpTimeConsistencyOption[WakeUpTimeConsistencyOption["differentTime"] = 2] = "differentTime";
  WakeUpTimeConsistencyOption[WakeUpTimeConsistencyOption["dependsOnWork"] = 3] = "dependsOnWork";
  return WakeUpTimeConsistencyOption;
}(WakeUpTimeConsistencyOption || {});
export var DailyRoutineConsistencyOption = /*#__PURE__*/function (DailyRoutineConsistencyOption) {
  DailyRoutineConsistencyOption[DailyRoutineConsistencyOption["setRoutine"] = 1] = "setRoutine";
  DailyRoutineConsistencyOption[DailyRoutineConsistencyOption["sometimesRoutine"] = 2] = "sometimesRoutine";
  DailyRoutineConsistencyOption[DailyRoutineConsistencyOption["noRoutine"] = 3] = "noRoutine";
  return DailyRoutineConsistencyOption;
}(DailyRoutineConsistencyOption || {});
export var SnoozeOption = /*#__PURE__*/function (SnoozeOption) {
  SnoozeOption[SnoozeOption["mostDays"] = 1] = "mostDays";
  SnoozeOption[SnoozeOption["someTimes"] = 2] = "someTimes";
  SnoozeOption[SnoozeOption["never"] = 3] = "never";
  return SnoozeOption;
}(SnoozeOption || {});